import { SidebarProjectsIcon } from "@libs/zapi-ui/assets";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { SidebarCollapseFooter } from "@/zapi-frontend/shared/ui/SidebarCollapseFooter/SidebarCollapseFooter";
import { useTranslation } from "react-i18next";

type TProps = {
  collapsed: boolean;
  isOverlay: boolean;
  onToggleCollapsed: () => void;
};

function SidebarLabel({ visible, children }: { visible: boolean; children: string }) {
  return (
    <span
      aria-hidden={!visible}
      className={cn(
        "overflow-hidden transition-[max-width,opacity] duration-200",
        visible ? "max-w-[132px] opacity-100" : "max-w-0 opacity-0"
      )}
    >
      <span className="block truncate whitespace-nowrap text-[14px] leading-4 font-medium">{children}</span>
    </span>
  );
}

export function ProjectListSidebar({ collapsed, isOverlay, onToggleCollapsed }: TProps) {
  const { t } = useTranslation("projects");
  const floating = isOverlay && !collapsed;

  return (
    <div
      className={cn(
        "relative shrink-0 transition-[width] duration-200",
        isOverlay ? "w-12" : collapsed ? "w-12" : "w-60"
      )}
    >
      {floating && (
        <button
          type="button"
          aria-label="Close sidebar"
          onClick={onToggleCollapsed}
          className="fixed inset-0 z-10 cursor-default bg-transparent"
        />
      )}
      <aside
        data-testid="projects-sidebar"
        className={cn(
          "flex flex-col justify-between overflow-hidden bg-white transition-[width] duration-200",
          floating
            ? "absolute inset-y-0 left-0 z-20 w-60 border-r border-innoveraZinc-100 shadow-300"
            : cn("h-full", collapsed ? "w-12" : "w-60")
        )}
      >
        <div className="flex flex-col py-1">
          <div className="flex flex-col gap-px px-2 py-1.5">
            <div
              className={cn(
                "flex items-center gap-2 h-8 p-2 rounded-lg bg-innoveraZinc-100 text-innoveraZinc-900",
                collapsed && !floating && "justify-center gap-0"
              )}
            >
              <SidebarProjectsIcon className="shrink-0" />
              <SidebarLabel visible={!collapsed || floating}>{t("sidebar.projects")}</SidebarLabel>
            </div>
          </div>
        </div>

        <SidebarCollapseFooter collapsed={collapsed && !floating} onToggle={onToggleCollapsed} />
      </aside>
    </div>
  );
}
